<script>
import { mapActions, mapGetters } from 'vuex'
import { validateCategory } from '@utils/validators/category'
import { invalid, dirty, validate } from '@/src/utils/validators/common'
export default {
  name: 'AnnouncementForm',

  props: {
    form: {
      type: Object,
      required: true,
    },
    canSubmit: {
      type: Function,
      required: true,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters('announcement', ['allAnnouncement']),
    ...mapGetters('category', ['allCategories']),

  },

  methods: {
    ...mapActions('account', ['getAccountsForDropDown']),

    validate: validate,
    invalid: invalid,
    dirty: dirty,
  },
  validations: {
    ...validateCategory,
  },
}
</script>

<template>
  <div>
    <div class="col-lg-12 route-group-form card">
      <form class="card-body" @submit.prevent>
        <div class="row form-group">
          <div class="col-12">
            <input
              id="name"
              v-model="form.name"
              type="text"
              name="name"
              placeholder=" "
              class="form-control pg-input"
              :class="{
                'is-invalid': invalid('name') && dirty('name'),
                'is-valid': !invalid('name') && dirty('name'),
              }"
              @input="validate('name')"
            />
            <label
              for="name"
              class="col-form-label pg-lable label-required"
              :class="{ active: form.name }"
              >Name
            </label>
          </div>
        </div>
        <div class="row form-group">
          <div class="col-12">
            <textarea
              id="description"
              v-model="form.description"
              type="text"
              name="description"
              placeholder=" "
              class="form-control pg-input"
              :class="{
                'is-invalid': invalid('description') && dirty('description'),
                'is-valid': !invalid('description') && dirty('description'),
              }"
              @input="validate('description')"
            />
            <label
              for="description"
              class="col-form-label pg-lable pg-textarea-label label-required"
              :class="{ active: form.description }"
              >Description
            </label>
          </div>
        </div>
        <slot name="submit"></slot>
      </form>
    </div>
  </div>
</template>
